import React from "react";
import "./style.css";

export default function YogaFilters({ filters, onFilterChange }) {
  const handleChange = (key, value) => {
    onFilterChange({
      ...filters,
      [key]: value
    });
  };

  return (
    <div className="yoga-filters-container">
      <div className="yoga-filter-group">
        <label>Ordenar por:</label>
        <select 
          value={filters.sortBy} 
          onChange={(e) => handleChange("sortBy", e.target.value)}
          className="yoga-filter-select"
        >
          <option value="newest">Mais Recentes</option>
          <option value="trending">Em Alta</option>
          <option value="popular">Mais Populares</option>
          <option value="rated">Melhor Avaliados</option>
          <option value="duration_asc">Menor Duração</option>
          <option value="duration_desc">Maior Duração</option>
        </select>
      </div>

      <div className="yoga-filter-group">
        <label>Tipo:</label>
        <select 
          value={filters.postType} 
          onChange={(e) => handleChange("postType", e.target.value)}
          className="yoga-filter-select"
        >
          <option value="">Todos</option>
          <option value="class">Aula Completa</option>
          <option value="tutorial">Tutorial</option>
          <option value="meditation">Meditação</option>
          <option value="breathing">Respiração</option>
          <option value="sequence">Sequência</option>
          <option value="challenge">Desafio</option>
          <option value="tip">Dicas</option>
        </select>
      </div>

      <div className="yoga-filter-group">
        <label>Nível:</label>
        <select 
          value={filters.level} 
          onChange={(e) => handleChange("level", e.target.value)}
          className="yoga-filter-select"
        >
          <option value="">Todos</option>
          <option value="beginner">Iniciante</option>
          <option value="intermediate">Intermediário</option>
          <option value="advanced">Avançado</option>
          <option value="all_levels">Todos os Níveis</option>
        </select>
      </div>

      <div className="yoga-filter-group">
        <label>Estilo:</label>
        <select 
          value={filters.yogaStyle} 
          onChange={(e) => handleChange("yogaStyle", e.target.value)}
          className="yoga-filter-select"
        >
          <option value="">Todos</option>
          <option value="hatha">Hatha</option>
          <option value="vinyasa">Vinyasa</option>
          <option value="ashtanga">Ashtanga</option>
          <option value="yin">Yin</option>
          <option value="restorative">Restaurativo</option>
          <option value="kundalini">Kundalini</option>
          <option value="hot_yoga">Hot Yoga</option>
          <option value="power_yoga">Power Yoga</option>
          <option value="gentle">Suave</option>
        </select>
      </div>

      <div className="yoga-filter-group">
        <label>Foco:</label>
        <select 
          value={filters.focus} 
          onChange={(e) => handleChange("focus", e.target.value)}
          className="yoga-filter-select"
        >
          <option value="">Todos</option>
          <option value="flexibility">Flexibilidade</option>
          <option value="strength">Força</option>
          <option value="balance">Equilíbrio</option>
          <option value="relaxation">Relaxamento</option>
          <option value="stress_relief">Alívio do Estresse</option>
          <option value="energy_boost">Energia</option>
          <option value="back_care">Cuidados com as Costas</option>
          <option value="hip_opening">Abertura de Quadril</option>
        </select>
      </div>

      <div className="yoga-filter-group">
        <label>Duração (min):</label>
        <div className="duration-inputs">
          <input 
            type="number" 
            placeholder="Mín"
            value={filters.minDuration}
            onChange={(e) => handleChange("minDuration", e.target.value)}
            className="yoga-filter-input"
            min="0"
          />
          <span>até</span>
          <input 
            type="number" 
            placeholder="Máx"
            value={filters.maxDuration}
            onChange={(e) => handleChange("maxDuration", e.target.value)}
            className="yoga-filter-input"
            min="0"
          />
        </div>
      </div>

      <button 
        className="yoga-filter-reset"
        onClick={() => onFilterChange({
          sortBy: "newest",
          postType: "",
          level: "",
          yogaStyle: "",
          focus: "",
          minDuration: "",
          maxDuration: ""
        })}
      >
        Limpar Filtros
      </button>
    </div>
  );
}
